const get = require('lodash/get');
const isEqual = require('lodash/isEqual');

module.exports = (pairs, source) => pairs
    .filter(([key, value]) => !isEqual(value, get(source, key)));
